import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/* eslint-disable @angular-eslint/no-input-rename */

@Component({
  selector: 'rdo-rate-type-card',
  templateUrl: 'rate-type-card.component.html',
  styles: `
    .rate-type-card-header {
      padding: 10px 10px 10px 15px;
    }

    .cell-container {
      container-type: inline-size;
      display: flex;
      flex-wrap: wrap;
    }

    .cell {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .title,
    .data {
      width: auto;
    }

    @container (min-width: 225px) {
      .cell {
        width: 50%;
        flex-direction: column;
      }

      .cell.right .title,
      .cell.right .data {
        text-align: end;
      }

      .title,
      .data {
        width: 100%;
      }

      .data {
        padding-top: 3px;
      }
    }
  `,
  standalone: false,
})
export class RateTypeCardComponent {
  @Input('title-name')
  titleName: string;
  @Input('sub-title-name')
  subTitleName: string;
  @Input('difference-title')
  differenceTitle: string =
    'main.tabs.equipment.product_types.rate_types.cards.bench_difference';
  @Input('first-value')
  firstValue: number;
  @Input('second-value')
  secondValue: number;
  @Input('title-value')
  titleValue;

  constructor(protected translateService: TranslateService) {}
}
